/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto. Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Custom JS loaded and DOM fully parsed');

    // VÁŠ NOVÝ TRACKING KÓD ZAČÍNÁ ZDE
    analytics.subscribe("checkout_completed", (event) => {
      const checkoutData = event.data.checkout;

      // Získání domény eshopu
      const shopDomain = window.location.hostname;
      console.log("[DEBUG] Shop Domain:", shopDomain);

      // Zde můžete použít doménu k rozlišení eshopu
      // Například pro nastavení různých campaignId na základě domény
      let campaignId;
      if (shopDomain.includes("kolorky.cz")) {
        campaignId = 'bb45fa37'; // Campaign ID pro eshop v ČR
      } else if (shopDomain.includes("kolorky.sk")) {
        campaignId = '67e1b486'; // Campaign ID pro eshop na Slovensku
      } else {
        // Výchozí nebo jiná logika
        campaignId = 'bb45fa37';
      }

      // Zbytek vašeho kódu...
      const marketHandle = checkoutData.localization.market.handle;
      let taxValue;
      if (marketHandle === 'cz') {
        taxValue = 1.21;
      } else if (marketHandle === 'sk') {
        taxValue = 1.23;
      }
      
      // Celková cena objednávky vč. DPH bez dopravy
      const deliveryCost = (checkoutData.shippingLine?.price?.amount || 0) / taxValue;

      const totalTax = checkoutData.totalTax.amount;
      
      const totalCost = checkoutData.totalPrice.amount - deliveryCost - totalTax;

      const totalCostRounded = Math.round(totalCost * 100) / 100;
      
      // Číslo objendávky
      const orderId = checkoutData.order.id;
      
      // Měna
      const orderCurrency = checkoutData.totalPrice.currencyCode;
      
      // Produkty objendávky v array
      const orderItems = checkoutData.lineItems.map(item => item.variant.sku);

      (function(d,t) {
        var placeholder = d.createElement('div');
        placeholder.id = 'papSaleTrackingPlaceholder';
        document.body.insertBefore(placeholder, document.body.firstChild);
        
        var script = d.createElement(t); script.id= 'pap_x2s6df8d'; script.async = true;
        script.src = '//login.dognet.sk/scripts/fj27g82d';
        script.onload = script.onreadystatechange = function() {
          var rs = this.readyState; if (rs && (rs != 'complete') && (rs != 'loaded')) return;
          
          PostAffTracker.setAccountId('8d4bd8e9'); // DONE
          var sale = PostAffTracker.createSale();
          sale.setCampaignID(campaignId); // Použití dynamicky získaného campaignId
          sale.setTotalCost(totalCostRounded); // DONE
          sale.setCoupon(''); // jen pokud jsou nějací influenceři
          sale.setOrderID(orderId); // DONE
          sale.setProductID(orderItems); // DONE
          sale.setCurrency(orderCurrency); // DONE
          try { PostAffTracker.track(); } catch (e) {}
        }
        var existingPlaceholder = document.getElementById('papSaleTrackingPlaceholder');
        existingPlaceholder.parentNode.insertBefore(script, existingPlaceholder);
        existingPlaceholder.parentNode.removeChild(existingPlaceholder);
      })(document, 'script');
    });
    // VÁŠ NOVÝ TRACKING KÓD KONČÍ ZDE
    
    let isUpdating = false;
    function debouncedUpdateProgressBar() {
      if (isUpdating) return;
      isUpdating = true;
      updateAllProgressBars();
      setTimeout(() => { isUpdating = false; }, 500);
    }

    function updateProgressBarElement(containerId, fillId, textId) {
      const container = document.getElementById(containerId);
      if (!container) return;
      
      const discountType = container.dataset.discountType;
      const discountValue = Number(container.dataset.discountValue);
      const ctaText = container.dataset.ctaText;
      const successText = container.dataset.successText;
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const threshold = cart.currency === 'EUR' ? Number(container.dataset.threshold_eur) : Number(container.dataset.threshold);
          console.log('Currency:', cart.currency);
          console.log('Threshold:', threshold);
          const originalTotal = cart.original_total_price;
          const progress = Math.min((originalTotal / threshold) * 100, 100);
          const remaining = (threshold - originalTotal) / 100;
          const currency = cart.currency;
          const currencySymbol = currency === 'CZK' ? 'Kč' : currency === 'EUR' ? '€' : currency;
          const discountDisplay = discountType === 'percent'
            ? `${discountValue}%`
            : `${(discountValue / 100).toFixed(2)} ${currencySymbol}`;
          
          const fill = document.getElementById(fillId);
          const text = document.getElementById(textId);
          const barProduct = container.querySelector('#progress-bar-product');
          const barDrawer = container.querySelector('#progress-bar-drawer');
          
          if (fill) fill.style.width = `${progress}%`;
          
          if (originalTotal >= threshold) {
            if (barProduct) barProduct.style.display = 'none';
            if (barDrawer) barDrawer.style.display = 'none';
            if (text) text.textContent = successText.replace('[discount]', discountDisplay);
          } else {
            if (barProduct) barProduct.style.display = '';
            if (barDrawer) barDrawer.style.display = '';
            if (text) {
              text.innerHTML = ctaText
                .replace('[remaining]', '<span class="bold">' + remaining.toFixed(2).replace('.', ',') + '</span>')
                .replace('[discount]', '<span class="bold">' + discountDisplay + '</span>')
                .replace('[currency]', '<span class="bold">' + currencySymbol + '</span>');
            }
          }
        });
    }
    
    function updateAllProgressBars() {
      updateProgressBarElement('discount-progress-container-product', 'discount-progress-fill-product', 'discount-progress-text-product');
      updateProgressBarElement('discount-progress-container-drawer', 'discount-progress-fill-drawer', 'discount-progress-text-drawer');
    }
    
    const cartObserver = new MutationObserver((mutations) => {
      const isRelevantMutation = mutations.some(mutation => {
        // Ignoruj změny uvnitř našich progress bar kontejnerů
        return !mutation.target.closest('#discount-progress-container-product') &&
               !mutation.target.closest('#discount-progress-container-drawer');
      });
      if (isRelevantMutation) {
        console.log('Relevant cart mutation observed');
        debouncedUpdateProgressBar();
      }
    });
    
    function observeCartChanges(selector) {
      document.querySelectorAll(selector).forEach(target => {
        cartObserver.observe(target, { childList: true, subtree: true, attributes: false });
      });
    }
    
    observeCartChanges('#cart-drawer');
    observeCartChanges('#kosik');
    observeCartChanges('.product__form[action="/cart/add"]');
    
    // Initial load
    updateAllProgressBars();
  });

  document.addEventListener('DOMContentLoaded', function() {
    
    if (window.innerWidth <= 767) {
      const sidebar = document.querySelector('.customer-account .sidebar');
      const sidebarList = sidebar.querySelector('ul');
      
      // Create and append navigation buttons
      const prevButton = document.createElement('button');
      prevButton.className = 'sidebar-nav-button sidebar-prev';
      prevButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      const nextButton = document.createElement('button');
      nextButton.className = 'sidebar-nav-button sidebar-next';
      nextButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      sidebar.insertBefore(prevButton, sidebarList);
      sidebar.appendChild(nextButton);

      // Scroll handling
      const scrollAmount = sidebarList.offsetWidth * 0.8; // 50% of container width

      prevButton.addEventListener('click', () => {
        sidebarList.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        sidebarList.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      });

      // Update button visibility
      const updateButtonVisibility = () => {
        prevButton.classList.toggle('hidden', sidebarList.scrollLeft <= 0);
        nextButton.classList.toggle('hidden', 
          sidebarList.scrollLeft + sidebarList.offsetWidth >= sidebarList.scrollWidth);
      };

      sidebarList.addEventListener('scroll', updateButtonVisibility);
      window.addEventListener('resize', updateButtonVisibility);
      updateButtonVisibility();
    }

    // Address Manager
    class AddressManager {
      constructor() {
        this.initializeElements();
        this.bindEvents();
        this.initializeCountryProvinceSelectors();
      }

      initializeElements() {
        // Modals
        this.newAddressModal = document.querySelector('.js-modal');
        this.editAddressModal = document.querySelector('.js-edit-modal');
        
        // Buttons
        this.newAddressButton = document.querySelector('.js-address-new');
        this.editButtons = document.querySelectorAll('.js-edit-address');
        this.deleteButtons = document.querySelectorAll('.js-delete-address');
        this.closeButtons = document.querySelectorAll('.js-modal-close');
        
        // Forms
        this.editForms = document.querySelectorAll('.js-edit-form');

        // Add modal content selections
        this.newModalContent = document.querySelector('.js-modal-content');
        this.editModalContent = document.querySelector('.js-edit-modal-content');
      }

      bindEvents() {
        // New address
        if (this.newAddressButton) {
          this.newAddressButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.showModal(this.newAddressModal);
          });
        }

        // Edit addresses
        this.editButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const formId = button.getAttribute('data-form-id');
            const form = document.querySelector(`#EditAddress_${formId}`);
            if (form) {
              this.showEditForm(form);
              console.log('Edit button clicked', {formId, form, modal: this.editAddressModal});
            }
          });
        });

        // Delete addresses
        this.deleteButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const formId = button.getAttribute('data-form-id');
            if (confirm(this.newAddressModal.getAttribute('data-confirm-message'))) {
              const deleteForm = document.createElement('form');
              deleteForm.method = 'POST';
              deleteForm.action = `/account/addresses/${formId}`;

              const methodInput = document.createElement('input');
              methodInput.type = 'hidden';
              methodInput.name = '_method';
              methodInput.value = 'delete';

              const authenticityInput = document.createElement('input');
              authenticityInput.type = 'hidden';
              authenticityInput.name = 'authenticity_token';
              authenticityInput.value = window.Shopify?.routes?.authenticity_token || '';

              deleteForm.appendChild(methodInput);
              deleteForm.appendChild(authenticityInput);
              document.body.appendChild(deleteForm);
              deleteForm.submit();
            }
          });
        });

        // Close modals
        this.closeButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const modal = button.closest('.modal');
            if (modal) {
              this.hideModal(modal);
            }
          });
        });

        // Close on outside click and ESC key
        window.addEventListener('click', (e) => {
          if (e.target.classList.contains('modal')) {
            this.hideModal(e.target);
          }
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            const activeModal = document.querySelector('.modal.active');
            if (activeModal) {
              this.hideModal(activeModal);
            }
          }
        });
      }

      initializeCountryProvinceSelectors() {
        const countrySelectors = document.querySelectorAll('.js-country-selector');
        
        countrySelectors.forEach(selector => {
          const formId = selector.getAttribute('data-form-id') || 'New';
          const provinceSelector = document.getElementById(`AddressProvince_${formId}`);
          const provinceWrapper = selector.closest('form').querySelector('.js-province-wrapper');
          
          if (provinceSelector && provinceWrapper) {
            const defaultCountry = selector.getAttribute('data-default');
            const defaultProvince = provinceSelector.getAttribute('data-default');

            if (defaultCountry) {
              this.updateProvinceSelect(selector, provinceSelector, provinceWrapper, defaultProvince);
            }

            selector.addEventListener('change', () => {
              this.updateProvinceSelect(selector, provinceSelector, provinceWrapper);
            });
          }
        });
      }

      updateProvinceSelect(countrySelect, provinceSelect, wrapper, defaultValue = null) {
        const provinces = window.Shopify.countries[countrySelect.value] || {};
        const provinceArray = Object.entries(provinces).map(([code, [name]]) => ({
          code,
          name
        }));

        provinceSelect.innerHTML = '';
        
        if (provinceArray.length) {
          provinceArray.forEach(province => {
            const option = document.createElement('option');
            option.value = province.code;
            option.textContent = province.name;
            provinceSelect.appendChild(option);
          });

          if (defaultValue) {
            provinceSelect.value = defaultValue;
          }

          wrapper.style.display = '';
        } else {
          wrapper.style.display = 'none';
        }
      }

      showModal(modal) {
        if (!modal) return;
        
        modal.classList.remove('hidden');
        modal.classList.add('active');
        
        const modalContent = modal.querySelector('.modal-content');
        if (modalContent) {
          modalContent.classList.add('active');
        }
        
        document.body.style.overflow = 'hidden';
      }

      hideModal(modal) {
        if (!modal) return;
        
        modal.classList.remove('active');
        
        const modalContent = modal.querySelector('.modal-content');
        if (modalContent) {
          modalContent.classList.remove('active');
        }
        
        document.body.style.overflow = '';
        
        const form = modal.querySelector('form');
        if (form) {
          form.reset();
        }
      }

      showEditForm(form) {
        const modal = this.editAddressModal;
        if (!modal) {
          console.error('Edit modal not found');
          return;
        }

        const formId = form.getAttribute('data-form-id');
        const originalForm = document.getElementById(`EditAddress_${formId}`);
        
        // Show modal and add active classes
        modal.style.display = 'flex';
        modal.classList.remove('hidden');
        modal.classList.add('active');
        
        const modalContent = modal.querySelector('.modal-content');
        if (modalContent) {
          modalContent.classList.add('active');
        }
        
        const modalBody = modal.querySelector('.modal-body');
        if (!modalBody) {
          console.error('Modal body not found');
          return;
        }
        
        const formClone = originalForm.cloneNode(true);
        formClone.classList.remove('is-hidden');
        formClone.style.display = 'block';
        
        const formElement = formClone.querySelector('form');
        if (formElement) {
          formElement.action = `/account/addresses/${formId}`;
        }
        
        modalBody.innerHTML = '';
        modalBody.appendChild(formClone);
        
        // Add class to body to prevent scrolling
        document.body.classList.add('modal-open');
        
        // Initialize country/province selectors
        const countrySelect = formClone.querySelector(`#AddressCountry_${formId}`);
        if (countrySelect) {
          const provinceSelect = formClone.querySelector(`#AddressProvince_${formId}`);
          const provinceContainer = formClone.querySelector(`#AddressProvinceContainer_${formId}`);
          
          if (provinceSelect && provinceContainer) {
            const defaultCountry = countrySelect.getAttribute('data-default');
            const defaultProvince = provinceSelect.getAttribute('data-default');
            
            if (defaultCountry) {
              countrySelect.value = defaultCountry;
              this.updateProvinceSelect(countrySelect, provinceSelect, provinceContainer, defaultProvince);
            }
            
            countrySelect.addEventListener('change', () => {
              this.updateProvinceSelect(countrySelect, provinceSelect, provinceContainer);
            });
          }
        }
      }
    }

    // Initialize AddressManager if we're on the addresses page
    if (document.querySelector('.js-modal')) {
      new AddressManager();
    }
  }); // Konec prvního document.addEventListener('DOMContentLoaded')

  // Můžete přidat druhý document.addEventListener('DOMContentLoaded') nebo kód,
  // který nepotřebuje čekat na DOM, přímo sem.
  // Ale pro většinu úloh je nejlepší být uvnitř DOMContentLoaded.

})();